import { ConnectisPrimaryLogo, ServiceUnavailableImg } from 'icons';
import { useTranslation } from 'react-i18next';

export const ServiceUnavailablePage = () => {
  const { t } = useTranslation();

  return (
    <main className="flex bg-background min-h-[100dvh] flex-col">
      <header className="shadow-error-header flex h-12 w-full items-center bg-white lg:h-16">
        <ConnectisPrimaryLogo className="ml-4 flex w-[120px] md:ml-6 md:w-[136px] lg:mb-0" />
      </header>
      <div className="mx-auto flex h-full flex-1 flex-col items-center justify-center gap-8 lg:flex-row lg:gap-20">
        <div>
          <ServiceUnavailableImg className="max-h-[360px] w-screen max-w-full p-4 px-[72px] lg:max-h-full lg:max-w-[519px] lg:px-0" />
        </div>
        <div className="max-w-[343px] space-y-3 text-center sm:my-4 md:max-w-[500px] lg:text-left">
          <h2 className="text-lg font-dmSans font-bold md:text-2xl">
            {t('errorPages:serviceUnavailable.title')}
          </h2>
          <p className="text-sm font-dmSans text-gray-450 md:text-lg lg:whitespace-pre-line">
            {t('errorPages:serviceUnavailable.subtitle')}
          </p>
        </div>
      </div>
    </main>
  );
};

export default ServiceUnavailablePage;
